export const GET_ALL_EMPLOYEE_SALARY: string = "GET_ALL_EMPLOYEE_SALARY";
export const GET_ONE_EMPLOYEE_SALARY: string = "GET_ONE_EMPLOYEE_SALARY";
export const LOADING: string = "LOADING";
